<template>
     <div>
        <el-button type="success"  @click="getLMSProgress(customer.email)">Unit Transcript</el-button>

        <el-dialog
          v-if="product"
        :visible.sync="transcriptVisible"
        width="50%"
        :modal="false"
        >
        <el-button type="success" @click="download()">Save</el-button>
        
        <!-- PDF Content that will be in pdf -->
        <div v-if="product" ref="pdfContent" style="padding:10px 20px 10px 20px;">   
          <div>
            <img ref="teflogo" src="../../../static/img/tefl-org-web.svg" width="150" style="margin-bottom:20px; float:left;">
            <h2 style="float:right;margin-top:-5px; font-size:20px;">Unit Transcript</h2>
          </div>
          <div style="position:relative; clear:both; margin-top:20px;">
            <img style="position:absolute; top:50%; right:50px; opacity:0.75; transform: rotate(10deg);" ref="stamp" src="../../../static/img/official-stamp-3.png" width="220">
          
            <div style="text-align: center; margin-bottom:20px;">
              <h3 style="font-size:20px; font-weight:bold; margin-bottom:10px; padding-top:20px; color:#000;">{{ product.product.name }}</h3>
              <p>is awarded to:</p>
              <h3 style="font-size:20px; font-weight:bold; margin-top:10px; margin-bottom:10px; color:#000;">{{ customer.firstname }}   {{ customer.middlenames }} {{ customer.lastname }}</h3>
              <p>on successful completion of the following units:</p>
            </div>
            <ul class="list-unstyled" style="padding-top:3px; padding-bottom: 20px;;">
              <li  v-for="course in progress" :key="course.id">
                <h5 style="background:#f5f5f5; padding:5px; margign-bottom:10px;">{{ course.courseName  }} - {{ course.enrollmentStatus }} <span style="float: right;"> <small>{{ course.enrollmentPassDate | moment('DD MMM YYYY') }}</small></span></h5> 
              
                <ul class="list-unstyled" style="margin-left:15px;font-size: 10px;margin-bottom:10px;">
                  <li v-for="lesson in course.lessons" :key="lesson.id">{{ lesson.name }} - {{   lesson.modules.every(obj => obj['status'] === 'passed')?'passed':'pending'}}</li>
                </ul>
              </li>
            </ul>
            <div style="text-align: center; margin-top:30px; margin-bottom:30px;">
              <p style=" font-size:14px;"><strong style=" color:#000;">Awarded on:</strong> {{ product.certSentDate || product.passedDate | moment("DD/MM/YYYY")}}<br />
              <strong style=" color:#000;">Certificate Number:</strong> {{ certid }}<br/>
            <strong style=" color:#000;">Guided Learning Hours:</strong> {{ product.product.course.hours }}</p>
            </div>
          </div>

          <div style="text-align: center;">
            <img style="margin:20px auto 0;" ref="accreditation" src="../../../static/img/accreditation_2024-uk.png" width="700">
          </div>

          <p style="text-align: center; font-size: 12px;">The TEFL Org, Suite Number 4, 8 Church Street, Inverness, IV1 1EA</p>
        </div>

        </el-dialog>
 
    </div>
    </template>
    <script>
    import html2pdf from 'html2pdf.js'
    import 'jspdf-autotable';
    import LMSapi from "../../api/lmsAPI";
    
    export default {
      props: ["customer","product","certid"],
      data() {
        return {
          transcriptVisible: false,
          loadingProgress: false,
            progress: [],
            tutor:''
        };
      },
      components: {},
      methods: {
        download() {
    
      var opt = {
        margin:       0.4,
        filename:     'Unit_Transcript-'+this.certid+'.pdf',
        image:        { type: 'webp', quality: 0.98 },
        html2canvas:  { scale: 2 },
        jsPDF:        { unit: 'in', format: 'letter', orientation: 'portrait' }
      };
    
    const content1 = this.$refs.pdfContent.innerHTML;
    html2pdf().set(opt).from(content1).save();
    
    
    },
        getLMSProgress(email,course_id) {
          this.loadingProgress = true;
          const course=this.product.cachedTeflLmsCourseId.split("|").slice(1, -1).map(Number)
          
          const progress = LMSapi.getProgress(email);
          console.log(progress)
          const tutor =  LMSapi.getTutor(email);
          Promise.all([progress,tutor])
            .then(([result,res]) => {
                //console.log("found",course,result.data.data.filter((c) => course.includes(c.courseId)));
              this.progress = result.data.data.filter(c => course.includes(c.courseId));
              this.loadingProgress = false;
              this.tutor=res.data.data
              this.transcriptVisible = true
            })
            .catch(e => {
              this.$notify({
                title: "Error",
                message: "Can't connect to the LMS right now",
                type: "error"
              });
            });
             
        }
      }
    };
    </script>
    <style>
    </style>


// WEBPACK FOOTER //
// src/components/UIComponents/UnitTranscript.vue